module.exports = __webpack_public_path__ + "media/images/design/images/icons/youtube-color-57c754062bf0068582dffb5e2a35a736.png";